import React from 'react';
import { FormattedMessage } from 'react-intl';
import { moduleHost } from '../../infrastructure/components/root-module-host';
import { connectThemesVM, ThemesContext } from './themes.context';
import { ThemesVM } from './themes.viewmodel';
import ThemesList from './_themes-list/themes-list';
import { LOADING } from '../../constants/common-labels.constants';

interface IProps {
    vm: ThemesVM;
}

const ThemesContainer = (props: IProps) => {
    const {vm} = props;

    if (vm.isListLoading) {
        return (
            <div>
                <FormattedMessage
                    {...LOADING}
                    values={{
                        suffix: '...'
                    }}
                />
            </div>
        );
    } else
        return <ThemesList vm={vm}/>;
};

const ThemesConnected = connectThemesVM<IProps>(ThemesContainer, vm => {
    return {
        vm: vm
    };
});

export const Themes = moduleHost(ThemesVM, ThemesContext, ThemesConnected);
